(function () {
  angular.module("akitabox.workOrder.detail").run(states);

  /* @ngInject */
  function states(Router) {
    Router.configureStates([
      {
        state: "app.building.workOrder.detail",
        config: {
          url: "",
          templateUrl: "app/mobile/modules/work-order/detail/detail.html",
          controller: "WorkOrderDetailController",
          controllerAs: "vm",
          data: {
            pageTitle: "Work Order",
          },
        },
      },
    ]);
  }
})();
